import { useEffect } from 'react';

import { useLogException } from '../error-boundary/utils';

/**
 * This component clears the referrer from the query parameters after the first render
 */
export const RemoveReferrer = () => {
	const logException = useLogException();

	useEffect(() => {
		try {
			const url = new URL(window.location.href);
			const searchParams = new URLSearchParams(url.search);

			if (!searchParams.has('referrer')) {
				return;
			}

			searchParams.delete('referrer');
			url.search = searchParams.toString();
			const { href } = url;

			window.history.replaceState(null, '', href);
		} catch (error) {
			logException(error);
		}
	}, [logException]);

	return null;
};
